import * as types from "@onflow/types";

export const optionalArgs = (value, type) => {
  if (value === null) {
    return [null, types.Optional(type)]
  }

  return [value, type];
}
